const SPOTLIGHT_SELECTOR = '[data-home-festival-spotlight]';

function initHomeFestivalSpotlight(root) {
    if (root.dataset.homeFestivalSpotlightReady === 'true') {
        return;
    }

    const slides = Array.from(
        root.querySelectorAll('[data-home-festival-slide]')
    );
    const dots = Array.from(
        root.querySelectorAll('[data-home-festival-dot]')
    );

    if (slides.length <= 1) {
        root.dataset.homeFestivalSpotlightReady = 'true';
        return;
    }

    let activeIndex = 0;
    let intervalId = null;

    const show = (index) => {
        activeIndex = (index + slides.length) % slides.length;

        slides.forEach((slide, slideIndex) => {
            slide.hidden = slideIndex !== activeIndex;
        });

        dots.forEach((dot, dotIndex) => {
            dot.setAttribute(
                'aria-current',
                dotIndex === activeIndex ? 'true' : 'false'
            );
        });
    };

    const stop = () => {
        if (intervalId !== null) {
            window.clearInterval(intervalId);
            intervalId = null;
        }
    };

    const start = () => {
        stop();

        intervalId = window.setInterval(() => {
            show(activeIndex + 1);
        }, 7000);
    };

    dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
            show(index);
            start();
        });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    root.dataset.homeFestivalSpotlightReady = 'true';

    show(0);
    start();
}

function bootHomeFestivalSpotlights() {
    document
        .querySelectorAll(SPOTLIGHT_SELECTOR)
        .forEach(initHomeFestivalSpotlight);
}

document.addEventListener(
    'DOMContentLoaded',
    bootHomeFestivalSpotlights
);

document.addEventListener(
    'livewire:navigated',
    bootHomeFestivalSpotlights
);
